import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const SampleSets = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { SampleSets, defaultState };
